<template>
  <Popover :trigger="trigger" :delay="delay">
    <template #default>
      <div class="helper-popover">
        <img class="helper-popover__image" :src="imageComp" v-if="imageComp" />
        <div class="helper-popover__content">
          <span class="helper-popover__title" v-if="titleComp">
            <slot name="title">
              {{ titleComp }}
            </slot>
          </span>
          <span class="helper-popover__description" v-if="bodyComp">
            <slot name="body">
              <span v-html="bodyComp"></span>
            </slot>
          </span>
          <a v-if="linkComp" class="helper-popover__link" :href="linkComp" target="_blank" :rel="titleComp">
            {{ $t('readMore') }}
          </a>
        </div>
      </div>
    </template>
  </Popover>
</template>

<script>
import Popover from '@/components/Popover'
import Items from './items'

const fieldGetter = function (key) {
  return function () {
    return this[key] || this.templateComp[key] || Boolean(this.$slots[key])
  }
}

export default {
  props: {
    title: String,
    body: String,
    link: String,
    image: String,
    template: String,
    trigger: {
      type: String,
      default: 'click',
    },
    delay: [String, Number],
  },
  computed: {
    titleComp: fieldGetter('title'),
    bodyComp: fieldGetter('body'),
    linkComp: fieldGetter('link'),
    imageComp: fieldGetter('image'),
    templateComp() {
      return Items(this).find(i => i.id === this.template) || {}
    },
  },

  components: {
    Popover,
  },
}
</script>

<style lang="scss">
.helper-popover {
  --padding: 1.5rem;

  overflow: hidden;
  max-width: 40ch;

  img {
    height: auto;
    max-width: 100%;
    padding-bottom: 1rem;
    background-color: rgba(white, 0.1);
    padding: var(--padding);
  }

  &__content {
    padding: var(--padding);
    display: flex;
    flex-direction: column;
    gap: 0.5em;
  }

  &__title {
    line-height: 1;
    font-weight: bold;
  }

  &__link {
    font-size: 0.9em;
    color: inherit;
    opacity: 0.75;
  }
  a {
    color: inherit;
  }

  &__description {
    line-height: 1.5;
    font-size: 0.9em;
  }

  &__list {
    margin: 0;
    padding: 0;

    &-item {
      list-style: none;
      padding-top: 0.7rem;

      &__label {
      }

      &__sublabel {
        opacity: 0.7;
        display: block;
      }
    }
  }
}
</style>
